export default __webpack_public_path__ + "static/media/header-back.59104bf4.jpg";